var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_9094)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9926 0H7.00735C3.13751 0 0.000244141 3.13714 0.000244141 7.0071V44.9926C0.000244141 48.8626 3.13738 51.9997 7.00735 51.9997H25.7415L25.7734 33.4179H20.9459C20.3185 33.4179 19.8093 32.9106 19.8069 32.2832L19.7837 26.2935C19.7813 25.6627 20.292 25.15 20.9228 25.15H25.7416V19.3624C25.7416 12.646 29.8436 8.98884 35.8351 8.98884H40.7516C41.3806 8.98884 41.8907 9.4988 41.8907 10.128V15.1785C41.8907 15.8074 41.381 16.3173 40.7522 16.3176L37.7351 16.319C34.4767 16.319 33.8458 17.8674 33.8458 20.1397V25.1501H41.0055C41.6877 25.1501 42.217 25.7458 42.1366 26.4233L41.4267 32.4131C41.3588 32.9862 40.8727 33.4181 40.2956 33.4181H33.8777L33.8458 52H44.9929C48.8627 52 51.9999 48.8629 51.9999 44.993V7.0071C51.9997 3.13714 48.8626 0 44.9926 0Z",
    fill: "#475993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_9094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.70ca34680f88eb338d3503b2c1a75fd8.svg";
export { ForwardRef as ReactComponent };